module.exports = __webpack_public_path__ + "img/agenda_02.35bd53c0.jpg";